import React, { Fragment, FC } from 'react';
import {
  ModalHeader,
  ModalSubHeader,
  ModalBody,
  Modal,
  ModalFooter,
  ModalClose,
  Button,
  ButtonAppearance,
  Box,
  Text,
  Separator,
  ModalSize,
} from '@bechtel/gds';
import { TitleValue, DrawerFooterButtonStyled } from '@bechtel/client-common';
import { map, join, uniq } from 'lodash';
import { t, Trans } from '@lingui/macro';
import { BlockNotCreatedProps } from './types';

export const BlockNotCreated: FC<BlockNotCreatedProps> = ({ onClose, blockErrors }) => {
  const error = Object.values(blockErrors)[0][0];
  const commodityType =
    error.milestone?.commodity?.materialCommodity?.type.name || error.milestone?.commodity?.weld?.type.name;

  return (
    <Fragment>
      <Modal size={ModalSize.LARGE} visible>
        <ModalHeader title={t`Alert Message`}>
          <ModalClose onClick={onClose}></ModalClose>
        </ModalHeader>
        <ModalSubHeader>
          <Text size="400">
            <Trans>
              Not all {commodityType}(s) were able to be blocked as they have already been claimed/approved/blocked.
            </Trans>
          </Text>
        </ModalSubHeader>
        <Box
          p={{ sm: '500' }}
          css={`
            ${({ theme }: any) => `background-color: ${theme.colors.grey[200]};`}
          `}
        >
          <Text size="400" weight="600">
            <Trans> Unable to Block:</Trans>
          </Text>
        </Box>
        <ModalBody>
          <Box
            style={{ whiteSpace: 'nowrap' }}
            pb={{ sm: '800' }}
            flexGrow={{ sm: 1 }}
            flexDirection={{ sm: 'column' }}
          >
            {map(blockErrors, (blockError, index) => {
              const commodity =
                blockError[0].milestone?.commodity.materialCommodity || blockError[0].milestone?.commodity.weld;
              return (
                commodity && (
                  <Fragment key={`${commodity.id}.${index}`}>
                    <Box justifyContent={{ sm: 'space-between' }} p={{ sm: '500' }}>
                      <TitleValue title={commodity.type.name} value={commodity.tag} size="500" />
                      <Box ml={{ sm: '500' }}>
                        <Text>
                          {join(
                            uniq(
                              map(blockError, (errorItem) => {
                                return errorItem.milestone?.name;
                              })
                            ),
                            ','
                          )}
                        </Text>
                      </Box>
                    </Box>
                    <Separator spacing="000" color="grey.200" />
                  </Fragment>
                )
              );
            })}
          </Box>
        </ModalBody>
        <ModalFooter>
          <Box justifyContent={{ sm: 'flex-end' }}>
            <Box>
              <DrawerFooterButtonStyled appearance={ButtonAppearance.SECONDARY} onClick={onClose}>
                <Box px={{ sm: '500' }}>
                  <Trans>Close</Trans>
                </Box>
              </DrawerFooterButtonStyled>
            </Box>
          </Box>
        </ModalFooter>
      </Modal>
    </Fragment>
  );
};
